import { Box, Stack } from '@mui/material';
import { Text } from '@src/components/mui';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useAppContext } from '~/contexts';

const Footer: FC = () => {
  const { COLORS } = useTheme();
  const { isMobile } = useAppContext();
  const currentYear = new Date().getFullYear();

  return (
    <Box component='footer' sx={{ backgroundColor: COLORS.primary.main, color: COLORS.text.white }}>
      <Stack sx={{ margin: 'auto', paddingY: { xs: 1, md: 2 }, paddingX: { xs: 1, md: 2 } }}>
        <Text
          variant='body1'
          color={COLORS.text.white}
          fontSize={isMobile ? 10 : 12}
          sx={{ display: { xs: 'block', md: 'inline' }, textAlign: 'center', opacity: 0.4 }}
        >
          {`${currentYear} e-método. All Rights Reserved`}
        </Text>
      </Stack>
    </Box>
  );
};

export { Footer };
